import {
  PREGUNTASFRECUENTES_SUCCESS,
  PREGUNTASFRECUENTES_LOADING,
  PREGUNTASFRECUENTES_ERROR,
  PREGUNTASFRECUENTES_RESET,
  RESET_PORTAL_CONTEXT,
} from "../ActionTypes";
import preguntasFrecuentesInitialState from "../initialStates/preguntasFrecuentesInitialState";

const preguntasFrecuente = (state, { payload, type }) => {
  switch (type) {
    case PREGUNTASFRECUENTES_LOADING:
      return {
        ...state,
        preguntasFrecuentes: {
          ...state.preguntasFrecuentes,
          error: false,
          loading: true,
        },
      };
    case PREGUNTASFRECUENTES_SUCCESS:
      return {
        ...state,
        preguntasFrecuentes: {
          ...state.preguntasFrecuentes,
          loading: false,
          error: false,
          data: payload,
        },
      };
    case PREGUNTASFRECUENTES_ERROR:
      return {
        ...state,
        preguntasFrecuentes: {
          ...state.preguntasFrecuentes,
          error: payload,
          loading: false,
        },
      };

    case PREGUNTASFRECUENTES_RESET:
      return preguntasFrecuentesInitialState;
    case RESET_PORTAL_CONTEXT:
      return preguntasFrecuentesInitialState;

    default:
      return state;
  }
};

export default preguntasFrecuente;
